// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill' // es6转码
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'qs'
import store from '@/assets/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/common.css'
import axpost from '@/assets/http' // axios
import VueWechatTitle from 'vue-wechat-title'
import CryptoJS from 'crypto-js'
import JsEncrypt from 'jsencrypt'
import Encrypt from '@/assets/until'
import VueKindEditor from 'kindeditor'
import apiUrl from '@/assets/config' // 接口api
import commJs from '@/assets/common' // 接口api
import VueAMap from 'vue-amap';
import layer from 'vue-layer';
import 'vue-layer/lib/vue-layer.css'
// import 'es6-promise/auto'
import myCharts from '@/assets/myCharts'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueWechatTitle)
Vue.prototype.Encrypt = Encrypt
Vue.prototype.CryptoJS = CryptoJS
Vue.prototype.$jsEncrypt = JsEncrypt
Vue.use(Vuex)
Vue.use(VueKindEditor)
Vue.use(VueAMap);
Vue.use(myCharts)
Vue.prototype.$qs = qs
Vue.prototype.comUrl = apiUrl
Vue.prototype.commJs = commJs
Vue.prototype.$axios = axpost
Vue.prototype.axios = axios
Vue.filter('formatDate', function(value) {
    let date = new Date(value);
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
})
Vue.prototype.$layer = layer(Vue, {
    msgtime: 3 // 目前只有一项，即msg方法的默认消失时间，单位：秒
});
VueAMap.initAMapApiLoader({
    key: '9097aed094fe96b6110307c3a991a776', // 高德的keye
    // 插件集合
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.convertFrom'],
    // 高德 sdk 版本，默认为 1.4.4
    v: '1.4.4',
    uiVersion: '1.0'
});
// 跳转新页面，回到页面顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})
router.afterEach((to, from, next) => {
    document.querySelector('body').setAttribute('style', 'overflow: auto !important;')
});
// 未登录状态跳转登录，还需在router.js中添加验证
router.beforeEach((to, from, next) => {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            console.log(localStorage, 'dl')
                // 这里判断用户是否登录，验证本地存储是否有token
            if (localStorage.getItem('islogin') === 'false' || localStorage.getItem('islogin') === null) { // 判断当前的token是否存在
                next({
                    name: 'login'
                })
            } else {
                next()
            }
        } else {
            next() // 确保一定要调用 next()
        }
    })
    // 获取网站的url，改变传参值
var docUrl = window.location.host
if (docUrl.startsWith('lunan')) {
    // 字符串是否在原字符串的头部
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031560';
    apiUrl.nodeCity.name = '路南';
} else if (docUrl.startsWith('lubei')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031561';
    apiUrl.nodeCity.name = '路北';
} else if (docUrl.startsWith('kaiping')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031563';
    apiUrl.nodeCity.name = '开平';
} else if (docUrl.startsWith('fengrun')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031565';
    apiUrl.nodeCity.name = '丰润';
} else if (docUrl.startsWith('fengnan')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031564';
    apiUrl.nodeCity.name = '丰南';
} else if (docUrl.startsWith('guye')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031562';
    apiUrl.nodeCity.name = '古冶';
} else if (docUrl.startsWith('caofeidian')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031571';
    apiUrl.nodeCity.name = '曹妃甸';
} else if (docUrl.startsWith('qianan')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031573';
    apiUrl.nodeCity.name = '迁安';
} else if (docUrl.startsWith('zunhua')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031572';
    apiUrl.nodeCity.name = '遵化';
} else if (docUrl.startsWith('qianxi')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031569';
    apiUrl.nodeCity.name = '迁西';
} else if (docUrl.startsWith('yutian')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031570';
    apiUrl.nodeCity.name = '玉田';
} else if (docUrl.startsWith('luanxian')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031566';
    apiUrl.nodeCity.name = '滦县';
} else if (docUrl.startsWith('luannan')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031567';
    apiUrl.nodeCity.name = '滦南';
} else if (docUrl.startsWith('laoting')) {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '031568';
    apiUrl.nodeCity.name = '乐亭';
} else {
    delete apiUrl.nodeCity.resourcePlatform;
    delete apiUrl.nodeCity.name;
    apiUrl.nodeCity.resourcePlatform = '0315';
    apiUrl.nodeCity.name = '唐山';
}
console.log(docUrl, 'documenturl')

// axios.defaults.withCredentials = false;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js